import React from "react";

/**
 * Segmented control (E §8 — e.g. SR urgency "Whenever / This week /
 * Urgent", pipeline list/board toggle). Single-select; friendly words,
 * never priority codes. options: [{ value, label }].
 */
function Segmented({ options, value, onChange, "aria-label": ariaLabel }) {
  return (
    <div className="fk-segmented" role="radiogroup" aria-label={ariaLabel}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={value === opt.value}
          className={`fk-segmented__opt${value === opt.value ? " fk-segmented__opt--on" : ""}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default Segmented;
